import template from './advertForm.html';
import controller from './advertForm.controller';
import './advertForm.scss';

let advertFormComponent = {
  restrict: 'E',
  bindings: {
    save: '&',
    storeFile: '&',
    advert: '=',
    socialMediaCategories: '<',
    linkValues: '=',
    linkTypes: '<',
    racedays: '<',
    locations: '<',
    nonRacingEvents: '<',
    validation: '<'
  },
  template,
  controller
};

export default advertFormComponent;
